// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__2bP1e","body":"body__1vWjI","header":"header__AHZ6v","footer":"footer__20er-"};